import { render, staticRenderFns } from "./CashierReport.vue?vue&type=template&id=2585856a&scoped=true"
import script from "./CashierReport.vue?vue&type=script&lang=js"
export * from "./CashierReport.vue?vue&type=script&lang=js"
import style0 from "./CashierReport.vue?vue&type=style&index=0&id=2585856a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585856a",
  null
  
)

export default component.exports